<template>
  <div class="container">
    <div class="container--section">

      <template v-if="canSms">
        <select v-model="form.isEmail" @change="alertTypeChange">
          <option
            v-for="(alertType, idx) in availableAlerts"
            :value="alertType.isEmail"
            :key="idx">{{alertType.title}}</option>
        </select>
      </template>

      <template v-else>
        Email
      </template>

      at

      <input type="email" placeholder="me@email.com" v-model="form.email" v-if="form.isEmail">
      <masked-input v-model="form.phone" mask="\+6\1 (01) 1111 1111" placeholder="phone number" type="text" v-else-if="this.$route.query.room == 49 || this.$route.query.room == 114 || this.$route.query.room == 131 || this.$route.query.room == 133 || this.$route.query.room == 178" />
      <masked-input v-model="form.phone" mask="\+\1 (111) 111-1111" placeholder="phone number" type="text" v-else />

      <div class="break">
        when

        <select v-model="form.washerCountAbove">
          <option
            v-for="i in thresholdRange"
            :value="i"
            :key="i">
              {{i}}
              <span v-if="i == 1">Washer</span>
              <span v-else>Washers</span>
          </option>
        </select>

        <select v-model="form.dryerCountAbove">
          <option
            v-for="i in thresholdRange"
            :value="i"
            :key="i">
              {{i}}
              <span v-if="i == 1">Dryer</span>
              <span v-else>Dryers</span>
            </option>
        </select>

        are available

        <div class="row">
          <div class="column" v-if="!validated">
            <button @click="submit" v-if="!isLoading">Send</button>
            <button v-if="isLoading" :disabled="isLoading">Sending...</button>
          </div>

          <span class="success" v-if="hasSubscribed">
            Thank you. We will reach out to you with your updates.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { submitRoomSubscription } from "../../services/data";
import MaskedInput from "vue-masked-input";

export default {
  name: "RoomSubscribe",
  props: {
    template: Object,
    canSms: Boolean
  },
  data() {
    return {
      isLoading: false,
      hasSubscribed: false,
      form: {
        isEmail: true,
        washerCountAbove: 0,
        dryerCountAbove: 0
      },
      availableAlerts: [
        {
          title: "Email me",
          isEmail: true
        },
        {
          title: "SMS me",
          isEmail: false
        }
      ],
      siteKey: window.siteKey,
    };
  },
  components: {
    MaskedInput
  },
  computed: {
    thresholdRange() {
      let arr = [];
      for (let i = 0; i < 20; i++) {
        arr.push(i);
      }
      return arr;
    },
    validated() {
      if (this.form.phone || this.form.email) {
        if (this.form.washerCountAbove > 0 || this.form.dryerCountAbove > 0) {
          this.hasSubscribed = false;
          return false;
        }
      }
      return true;
    }
  },
  methods: {
    alertTypeChange() {
      if (this.form.isEmail) {
        this.$delete(this.form, "phone");
      } else {
        this.$delete(this.form, "email");
      }
    },

    submit() {
      this.isLoading = true;

      grecaptcha.ready(() => {
        grecaptcha.execute(this.siteKey, {action: 'submit'}).then((recaptchaToken) => {
          this.form.recaptchaToken = recaptchaToken;

          submitRoomSubscription(this.$route.query.room, this.form, this.template).then(response => {
            this.hasSubscribed = true;
            this.form = {
              isEmail: true,
              washerCountAbove: 0,
              dryerCountAbove: 0
            };
          }).catch(e => {
            console.log("> e", e);
          }).finally(() => {
            this.isLoading = false;
          });
        });
      });
    }
  },
};
</script>

<style scoped>
.container {
  /* background: red; */
}

.container--section {
  background: white;
  border-top: 1px solid #d1d1d1;
  /* background: #9a52c7; */
}

.container--section select,
.container--section input {
  display: inline-block;
  width: auto;
  margin: 0 5px;
  /* border-color: transparent; */
}

.container--section > select:first-of-type {
  margin-left: 0;
}

.container--section button {
  margin-top: 10px;
  margin-bottom: 0;
  min-width: 200px;
}

.success {
  margin-left: 10px;
  color: #4bb659;
  padding: 10px 0 0 0;
  display: block;
}

.break {
  display: inline;
}

@media (max-width: 910px) {
  /* .container--section {
    text-align: left;
  } */

  .break {
    margin-top: 10px;
    display: inline-block;
  }
}

@media (max-width: 640px) {
  .container--section {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/room/RoomSubscribe.vue